import { createAction } from '@reduxjs/toolkit';

/**
 * "Signal" actions: intents the UI dispatches for the saga to act on (#762).
 * Kept out of the slice's reducers: they trigger side effects, not state
 * transitions.
 */

/** Read the queue: dispatched by the page when it opens, and by its Retry. */
export const loadRequested = createAction('exitsInvestmentsReview/loadRequested');
